import React, { useEffect } from 'react';
import { useModal } from '../../../../hooks/useModal';
const Modal = React.lazy(async () => await import('./Modal'));
let item;
export const AddedModal = () => {
    const [showed, openFn, closeFn] = useModal();
    useEffect(() => {
        document.addEventListener('addToCart', event => {
            item = event.detail.itemData;
            openFn();
        });
    }, []);
    return showed
        ? React.createElement(Modal, { item: item, closeHandler: closeFn })
        : null;
};
